import { useCallback } from 'react'
import type { RefObject } from 'react'
import { useFireEvent } from '@educator/tracking/educatorTracking'

/** Any carousel handle the row-scroll tracking can drive. */
export interface RowCarouselHandle {
  goToPrev: () => void
  goToNext: () => void
}

/**
 * Single source of truth for the program-section carousels' `educatorRowScrolled`
 * event. row_name/row_position_index are inherited from the section's
 * TrackingAttributes, so callers only supply the direction.
 */
export function useRowScroll<T extends RowCarouselHandle>(
  carouselRef: RefObject<T | null>,
) {
  const fireEvent = useFireEvent()

  // Arrow nav: report the scroll, then move the row.
  const scrollRow = useCallback(
    (direction: 'left' | 'right') => {
      fireEvent('educatorRowScrolled', { direction, auto_scroll: false })
      if (direction === 'left') carouselRef.current?.goToPrev()
      else carouselRef.current?.goToNext()
    },
    [fireEvent, carouselRef],
  )

  return { scrollRow }
}
